import Vue from "vue";

function loadImage(url) {
  // eslint-disable-next-line promise/param-names
  return new Promise(r => {
    const img = new Image();
    img.onload = () => r(img);

    // 这里做了特殊的处理
    // 如果图片加载失败,仍然返回 resolve, 只是内容为空
    img.onerror = () => r();
    img.src = url;
  });
}

function runAnimation(ctx, width, height, fps, frames, delay) {
  const tpf = Math.floor(1000 / fps);
  let lastRenderTime = 0;
  let currFrameIndex = -1;

  function draw(timestamp) {
    const shouldRender = timestamp - lastRenderTime >= tpf;

    if (shouldRender) {
      lastRenderTime = timestamp;
      currFrameIndex = (currFrameIndex + 1) % frames.length;

      if (frames[currFrameIndex]) {
        ctx.drawImage(frames[currFrameIndex], 0, 0, width, height);
        // 每次绘制时，都直接覆盖之前的图像，而不是与其混合，从而避免png黑边的出现
        ctx.globalCompositeOperation = "copy";
      }
    }

    // 循环播放
    if (delay && currFrameIndex === 0) {
      // 停留指定时间后再开始动画
      setTimeout(() => {
        window.requestAnimationFrame(draw);
      }, delay);
    } else {
      window.requestAnimationFrame(draw);
    }
  }

  // 第一次绘制
  window.requestAnimationFrame(draw);
}

/**
 * Initializes a frame animation on a canvas element.
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to draw the animation on.
 * @param {number} width - The width of the canvas.
 * @param {number} height - The height of the canvas.
 * @param {number} length - The number of frames in the animation.
 * @param {number} fps - The frames per second of the animation.
 * @param {Function} getImage - The base URL of the image frames.
 * @param {number} delay - The delay between the last frame and the first frame.
 * @return {Promise<void>} A promise that resolves when the animation is finished.
 */
const initFrameAnimation = async (
  canvas,
  width,
  height,
  length,
  fps,
  getImage,
  delay
) => {
  const ctx = canvas.getContext("2d");
  canvas.width = width;
  canvas.height = height;

  // 先加载所有图片资源
  const loadTasks = new Array(length)
    .fill(0)
    .map((_, i) => loadImage(getImage(i)));

  // 绘制
  const frames = await Promise.all(loadTasks);
  if (ctx) runAnimation(ctx, width, height, fps, frames, delay);
};

Vue.prototype.$initFrameAnimation = initFrameAnimation;
